import React from "react";
import { TRYON_SERVER_URL } from "../config";
import PictureCard from "./PictureCard";
import GradientFont from "./GradientFont";
import { CircleAlert } from "lucide-react";


export default function PictureGrid(props) {
    const experiment = props.experiment;

    return (
        <div className="flex w-full flex-col items-center justify-center overflow-hidden rounded-2xl bg-white shadow-[0_0_0_1px_var(--hairline)]">
            <div className="grid h-full w-full grid-cols-1 gap-3 p-3 sm:grid-cols-2 lg:grid-cols-3">

                {experiment?.model !== null ?(
                <PictureCard
                    key={experiment?.id}
                    experiment={experiment}
                    imageUrl={experiment?.model?.image_url}
                    label={"Original"}
                    index={0}
                    TRYON_SERVER_URL={TRYON_SERVER_URL}
                    loading={false}
                /> ):(<></>)}
                {experiment?.status === "completed" && (
                    <>
                        <PictureCard
                            key={experiment.result?.id || experiment.model?.id} 
                            experiment={experiment.result || experiment.model} 
                            imageUrl={experiment.result?.image_url || experiment.model?.image_url} 
                            label="Image 1"
                            index={1} 
                            TRYON_SERVER_URL={TRYON_SERVER_URL}
                            loading={false}
                        />
                      
                        {Array.isArray(experiment.results) && experiment.results.length > 0 &&
                            experiment.results.map((image, index) => {
                                const imageUrl = image?.image_url || experiment?.model?.image_url;
                                const label = `Image ${index + 2}`;

                                return (
                                    <PictureCard
                                        key={image.id}
                                        experiment={image}
                                        imageUrl={imageUrl}
                                        label={label}
                                        index={index + 2} 
                                        TRYON_SERVER_URL={TRYON_SERVER_URL}
                                        loading={false}
                                    />
                                );
                            })
                        }
                    </>
                )}

                {(experiment?.status === "pending" || experiment?.status === "running") &&
                    <>{experiment?.params && 
                        Array.from({ 
                            length: experiment.action === "model_swap" ? JSON.parse(experiment.params).num_images_per_prompt : JSON.parse(experiment.params).num_images_per_prompt 
                        }).map((_, i) => (
                            <PictureCard
                                key={`${experiment.id}-${i}`}
                                experiment={experiment}
                                imageUrl={experiment?.model?.image_url}
                                label="Loading..."
                                index={i}
                                TRYON_SERVER_URL={TRYON_SERVER_URL}
                                loading={true}
                            />
                        ))
                    }

                        {/* <PictureCard
                            key={experiment?.id}
                            experiment={experiment}
                            imageUrl={experiment?.model?.image_url}
                            label={"Original"}
                            index={0}
                            TRYON_SERVER_URL={TRYON_SERVER_URL}
                            loading={true}
                        />

                        <PictureCard
                            key={experiment.id +1}
                            experiment={experiment}
                            imageUrl={experiment.model?.image_url}
                            label={"Original"}
                            index={0}
                            TRYON_SERVER_URL={TRYON_SERVER_URL}
                            loading={true}
                        />

                        <PictureCard
                            key={experiment.id + 2}
                            experiment={experiment}
                            imageUrl={experiment.model?.image_url}
                            label={"Original"}
                            index={0}
                            TRYON_SERVER_URL={TRYON_SERVER_URL}
                            loading={true}
                        /> */}
                    </>
                }

                {experiment?.status === "failed" && (
                    <div className="inset-0 backdrop-blur-sm lg:col-span-4 rounded-2xl w-full h-full">
                        <div className="w-full h-full flex items-center justify-center">
                            <div className="bg-white/90 rounded-xl w-full p-6 shadow-sm">
                                <div className="flex flex-col items-center space-y-4 text-center">
                                    <div className="flex items-center justify-center">
                                        <CircleAlert className="mr-2 h-6 w-6 text-red-500 md:h-8 md:w-8" aria-label="Error" />
                                        <GradientFont>FAILED</GradientFont>
                                    </div>
                                    <p className="text-sm md:text-base text-gray-700">
                                        Generation failed. Try again or contact us at{' '}
                                        <a 
                                            href="mailto:contact@tryonlabs.ai" 
                                            className="underline text-[#BE3144] hover:text-[#BE3144]/80 transition-colors"
                                        >
                                            contact@tryonlabs.ai
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="w-full border-t border-hairline px-4 py-3 text-left">
                <div className="flex flex-wrap gap-2">
                    {experiment?.params &&
                        Object.entries(JSON.parse(experiment.params))
                            .filter(([key]) => key !== 'negative_prompt')
                            .map(([key, value]) => {
                                const formattedKey = key.replace(/_/g, ' ').charAt(0).toUpperCase() + key.replace(/_/g, ' ').slice(1);
                                return (
                                    key === "prompt" ? (
                                        <div key={key} className="w-full">
                                            <span className="font-Mulish text-sm font-semibold text-secondary">{formattedKey}:</span>
                                            <span className="ml-2 font-Mulish text-sm text-graphite">{value.toString()}</span>
                                        </div>
                                    ) : (
                                        <div 
                                            key={key} 
                                            className="flex items-center justify-start rounded-full bg-ground px-3 py-1.5 shadow-[0_0_0_1px_var(--hairline)]"
                                        >
                                            <span className="my-auto font-Mulish text-sm font-semibold text-secondary">
                                                {formattedKey.split(' ').map(word => 
                                                    word.charAt(0).toUpperCase() + word.slice(1)
                                                ).join(' ')}:
                                            </span>
                                            <span className="my-auto ml-1.5 font-Mulish text-sm text-graphite">
                                                {value.toString().split(' ').map(word => 
                                                    word.charAt(0).toUpperCase() + word.slice(1)
                                                ).join(' ')}
                                            </span>
                                        </div>
                                    )
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}   